import { cn } from '@forest/shared'
import { useStore } from '@nanostores/react'
import { native } from '@forest/native-services'
import { $isCloseButtonVisible } from '~/store/close-button'

export function CloseButton(props: { className?: string }) {
  const isVisible = useStore($isCloseButtonVisible)
  if (!isVisible) return null
  return (
    <button
      className={cn(
        'grid size-9 place-items-center overflow-hidden rounded-full backdrop-blur-[37.5px]',
        props.className,
      )}
      onClick={() => native.general.close()}
      style={{
        border: '1.5px solid rgba(255, 255, 255, 0.30)',
        background: 'rgba(255, 255, 255, 0.56)',
      }}
    >
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.21429 4.71442L13.7857 13.2858"
          stroke="#333333"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.21427 13.2858L13.7856 4.71442"
          stroke="#333333"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
